"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _styles = _interopRequireDefault(require("./styles.scss"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CLASS_NAME = _styles.default['colored-checkbox'];
var ColoredCheckbox = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ColoredCheckbox, _PureComponent);
  var _super = _createSuper(ColoredCheckbox);
  function ColoredCheckbox(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ColoredCheckbox);
    _this = _super.call(this, props);
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(ColoredCheckbox, [{
    key: "onChange",
    value: function onChange(e) {
      this.props.onChange(e.target.checked, e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        name = _this$props.name,
        className = _this$props.className,
        checked = _this$props.checked,
        disabled = _this$props.disabled,
        children = _this$props.children,
        style = _this$props.style,
        inputClassName = _this$props.inputClassName,
        isIndeterminateState = _this$props.isIndeterminateState;
      var id = "".concat(name).concat(new Date().getTime());
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(className, " ").concat(CLASS_NAME)
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.ControlLabel, {
        className: "colored-checkbox-content",
        htmlFor: id
      }, children, /*#__PURE__*/_react.default.createElement("input", {
        type: "checkbox",
        className: "".concat(inputClassName, " ").concat(isIndeterminateState ? 'indeterminate' : ''),
        style: style,
        checked: checked,
        disabled: disabled,
        id: id,
        name: name,
        onChange: this.onChange
      })));
    }
  }]);
  return ColoredCheckbox;
}(_react.PureComponent);
ColoredCheckbox.propTypes = {
  name: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]).isRequired,
  className: _propTypes.default.string,
  onChange: _propTypes.default.func,
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  /**
   * Checkbox color object format: { '--checkedColor': '#000000' }
   */
  style: _propTypes.default.shape({}),
  inputClassName: _propTypes.default.string,
  /**
    * Use `isIndeterminateState` to specify the indeterminate state of checkbox
    * using for checkbox parent have some child checkbox is selected
    */
  isIndeterminateState: _propTypes.default.bool
};
ColoredCheckbox.defaultProps = {
  name: 'checkbox',
  className: '',
  checked: false,
  disabled: false,
  onChange: function onChange() {
    return null;
  },
  style: {},
  inputClassName: '',
  isIndeterminateState: undefined
};
var _default = ColoredCheckbox;
exports.default = _default;